// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"332":"component---src-templates-index-js","532":"styles","662":"29107295"}[chunkId] || chunkId) + "-" + {"332":"a29db9cbe9b4835c42b6","532":"677ce0c8aa2b96ceac62","662":"881d2b2cf3801e5d815a","882":"72f04b87be561a673a6f"}[chunkId] + ".js";
};